import * as z from "zod";

export const getPayoutInvoicePdf = {
  name: "getPayoutInvoicePdf" as const,
  input: z.object({ teamId: z.string(), payoutId: z.string() }),
  output: z.object({ url: z.string() }),
};
